module.exports = __webpack_public_path__ + "static/media/logo-black.2a39e01b.svg";